import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EEventType } from '../../types/events';
import { ERegisterOrAuthStatus } from '../../types/phoneAuth';
import { PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE } from '../../constants/action_types';
import { jsonpRequest } from '../../../browser/utils/jsonpRequest';
import { registerOrAuthorizeUser } from '../../api/registerOrAuthorizeUser';
import { trackAuthenticateSuccess, trackPhoneAuthCallValidationFail, trackPhoneAuthExhausted, trackPhoneAuthSmsValidationFail, trackRegistrationSuccess } from '../../utils/tracking';
import { ERegisterOrAuthorizeEnhancedStatus } from '../../api/registerOrAuthorizeUser/transformRegisterOrAutorizeResonse';
import { changeView } from '../view';
import { EActiveView } from '../../..';
import { saveAccount } from '../../utils/rememberedAccounts';
import { ERememberedAccountType } from '../../types/rememberedAccounts';
import { ESenderType } from '../../api/sendCode';
export function registerOrAuthorize(_ref) {
  var code = _ref.code;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var _getState, _getState$phoneAuth, phone, senderType, agreement, isRememberAccountsFlow, res, email, token, logOnUrl, isRegistered, accounts, temporaryToken, errorMessage, _errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                status: ERegisterOrAuthStatus.Loading,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE
              });
              _getState = getState(), _getState$phoneAuth = _getState.phoneAuth, phone = _getState$phoneAuth.phone, senderType = _getState$phoneAuth.sendValidationCode.senderType, agreement = _getState.agreement, isRememberAccountsFlow = _getState.isRememberAccountsFlow;
              _context.prev = 2;
              _context.next = 5;
              return registerOrAuthorizeUser(context.httpApi, {
                code: code,
                phone: phone,
                isAcceptLicence: agreement.licenceAccepted,
                hasMarketingSubscriptions: agreement.marketingSubscriptionAccepted
              });
            case 5:
              res = _context.sent;
              _context.t0 = res.status;
              _context.next = _context.t0 === ERegisterOrAuthorizeEnhancedStatus.Success ? 9 : _context.t0 === ERegisterOrAuthorizeEnhancedStatus.ManyAccounts ? 23 : _context.t0 === ERegisterOrAuthorizeEnhancedStatus.CodeExpired ? 27 : _context.t0 === ERegisterOrAuthorizeEnhancedStatus.Wrong ? 30 : _context.t0 === ERegisterOrAuthorizeEnhancedStatus.CodeInputLimitReached ? 33 : _context.t0 === ERegisterOrAuthorizeEnhancedStatus.Error ? 36 : 39;
              break;
            case 9:
              email = res.email, token = res.token, logOnUrl = res.logOnUrl, isRegistered = res.isRegistered;
              _context.prev = 10;
              _context.next = 13;
              return jsonpRequest("".concat(logOnUrl, "?login=").concat(encodeURIComponent(email), "&token=").concat(token, "&persistent=true"));
            case 13:
              dispatch({
                status: ERegisterOrAuthStatus.Succeed,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE
              });
              if (isRegistered) {
                context.emitter.emit(EEventType.RegisterSucceed, {
                  email: email,
                  phone: phone,
                  senderType: senderType
                });
                trackRegistrationSuccess({
                  senderType: senderType
                });
              } else {
                context.emitter.emit(EEventType.AuthenticateSucceed, {
                  email: email,
                  phone: phone,
                  senderType: senderType
                });
                trackAuthenticateSuccess({
                  senderType: senderType
                });
              }
              if (isRememberAccountsFlow) {
                saveAccount({
                  type: ERememberedAccountType.Phone,
                  value: phone
                });
              }
              _context.next = 22;
              break;
            case 18:
              _context.prev = 18;
              _context.t1 = _context["catch"](10);
              context.logger.error(_context.t1, {
                domain: 'auth-widget.api.registerOrAuthorize#logon'
              });
              dispatch({
                status: ERegisterOrAuthStatus.Failed,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
                error: 'Произошла непредвиденная ошибка'
              });
            case 22:
              return _context.abrupt("break", 42);
            case 23:
              accounts = res.accounts, temporaryToken = res.temporaryToken;
              dispatch({
                status: ERegisterOrAuthStatus.ManyAccounts,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
                accounts: accounts,
                temporaryToken: temporaryToken
              });
              dispatch(changeView(EActiveView.AccountSelect));
              return _context.abrupt("break", 42);
            case 27:
              errorMessage = senderType === ESenderType.Call ? 'Истек срок действия кода' : 'Истек срок действия смс кода. Попробуйте ещё раз.';
              dispatch({
                status: ERegisterOrAuthStatus.Failed,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
                error: errorMessage
              });
              return _context.abrupt("break", 42);
            case 30:
              if (senderType === ESenderType.Call) {
                _errorMessage = 'Введён неверный код';
                trackPhoneAuthCallValidationFail();
              } else {
                _errorMessage = 'Введён неверный код. Попробуйте ещё раз.';
                trackPhoneAuthSmsValidationFail();
              }
              dispatch({
                status: ERegisterOrAuthStatus.Failed,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
                error: _errorMessage
              });
              return _context.abrupt("break", 42);
            case 33:
              trackPhoneAuthExhausted();
              dispatch({
                status: ERegisterOrAuthStatus.Failed,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
                error: 'Превышено количество попыток. Попробуйте позже.'
              });
              return _context.abrupt("break", 42);
            case 36:
              context.logger.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 ".concat(res.status));
              dispatch({
                status: ERegisterOrAuthStatus.Failed,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
                error: res.message || 'Произошла непредвиденная ошибка'
              });
              return _context.abrupt("break", 42);
            case 39:
              if (res.status === ERegisterOrAuthorizeEnhancedStatus.BrokenContract) {
                context.logger.error("\u041D\u0430\u0440\u0443\u0448\u0435\u043D \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442 ".concat(JSON.stringify(res.originalResponse)));
              } else {
                context.logger.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 ".concat(res.status));
              }
              dispatch({
                status: ERegisterOrAuthStatus.Failed,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
                error: 'Произошла непредвиденная ошибка'
              });
              return _context.abrupt("break", 42);
            case 42:
              _context.next = 48;
              break;
            case 44:
              _context.prev = 44;
              _context.t2 = _context["catch"](2);
              context.logger.error(_context.t2, {
                domain: 'auth-widget.api.registerOrAuthorize'
              });
              dispatch({
                status: ERegisterOrAuthStatus.Failed,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE,
                error: 'Произошла непредвиденная ошибка'
              });
            case 48:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 44], [10, 18]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}